import { Paragraph } from '@zillow/constellation-10';

import { css } from '@/styled-system/css';
import { shimmerStyles } from '../styles/ShimmerStyles';

import type { ParagraphPropsInterface } from '@zillow/constellation-10';

export const LoadingParagraph = ({
  isLoading,
  loadingWidth,
  children,
  css: cssProp,
  style: styleProp,
  ...rest
}: {
  isLoading: boolean;
  loadingWidth?: string;
} & Omit<ParagraphPropsInterface, 'ref'>) => (
  <Paragraph
    data-loading={isLoading || null}
    css={css.raw(cssProp, shimmerStyles, {
      _loading: { marginTop: cssProp?.marginTop || 'micro.default' },
    })}
    style={isLoading ? { width: loadingWidth ? loadingWidth : '100%', ...styleProp } : { ...styleProp }}
    {...rest}
  >
    {isLoading ? <>&nbsp;</> : children}
  </Paragraph>
);
